import { Box, Button, Typography } from "@mui/material"
import useStyles from "./styles"


export function DSFaz(){
  const classes = useStyles();
  
  return (
    <Box className={classes.rootStyle}>
      <Typography className={classes.textStyle}>
        Sem tempo para fazer propagandas e atualizar redes sociais?
        Deixe que nossa equipe faça por você!
      </Typography>
    
      <Button 
        href={"https://datasales.io/solucoes/dsfazb/?utm_source=appweb&utm_medium=banner&utm_campaign=dsfazinterna&utm_term=conhecaodsfaz&utm_content=textos"} 
        target={"_blank"}
        className={classes.buttonStyle}>
        Quero conhecer!
      </Button>

    </Box>
  );
}